<!--
  多版本菜单 B6（老扫码站 U-B6-3）：菜单预览横幅。地址里带着形状合法的 previewMenu（管理端预览链接）时顶部常驻一条：
    - 预览中：「Preview — orders can't be placed」（这一页看的是还没上线的菜单，不能下单，owner D56）；
    - 预览已结束：后端回了主菜单（停止分享 / 菜单已发布或归档，D88）→ kiosk 那句「This preview has ended — showing the main menu. …」（D84）。
  判定只读 utils/menu/previewMenuStatus.js（状态）与 previewMenu.js（码，现读地址）；没有码时整个不渲染（今天的全部页面逐像素不变）。
  pointer-events: none —— 纯提示，不挡任何点按；矮，尽量少盖住各页顶部。
  U-B6-2 review 第 2 轮 G12：顶部导航栏（components/global/NavBar，58px 高、fixed 在最上面）显示时排在它下面（以前盖在导航栏上，
  返回 / 菜单 / 语言这几个按钮看不见）；层级在页面内容之上（各页自己的层最高到 vant 吸顶的 99），在弹窗 / 遮罩（vant 2000 起）与加载圈（2400）之下。
-->
<template>
  <div
    v-if="status !== 'none'"
    class="preview_menu_banner"
    :class="classes"
    :data-state="status"
    role="status"
    aria-live="polite"
  >{{ text }}</div>
</template>

<script>
import { currentPreviewMenuToken } from '@/utils/menu/previewMenu'
import { previewMenuStatus } from '@/utils/menu/previewMenuStatus'
import { previewBannerText } from '@/utils/menu/previewMenuCopy'

export default {
  name: 'PreviewMenuBanner',
  props: {
    /** 顶部导航栏这一页显示着（App.vue 的 navConfig.barShow）⇒ 排在它下面 */
    belowNavBar: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /** 码现读地址；依赖 $route.query 只为让站内跳转触发重算；「已结束」是响应式的 */
    status() {
      const query = this.$route ? this.$route.query : undefined
      return previewMenuStatus(currentPreviewMenuToken(query))
    },
    text() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return previewBannerText(this.status)
    },
    classes() {
      return {
        'preview_menu_banner--ended': this.status === 'ended',
        'preview_menu_banner--below_nav': this.belowNavBar
      }
    }
  }
}
</script>

<style scoped lang="sass">
.preview_menu_banner
  position: fixed
  top: 0
  left: 0
  right: 0
  z-index: 100
  padding: 2px 12px
  font-size: 12px
  line-height: 18px
  font-weight: 600
  text-align: center
  pointer-events: none
  color: #0b4a6f
  background: #e0f2fe
  border-bottom: 1px solid #7dd3fc

// 与导航栏同一个高度（components/global/NavBar .nav_bar height: 58px，同样是会按屏宽换算的小写 px）
.preview_menu_banner--below_nav
  top: 58px

.preview_menu_banner--ended
  color: #92400e
  background: #fef3c7
  border-bottom-color: #fcd34d
</style>
